"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountNumber = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var AccountNumber = function (props) {
    if (!props.number) {
        return null;
    }
    var formatted = honeycomb_1.Formatters.formatAccountNumber(props.number, props.options);
    return (React.createElement("span", { className: (0, classnames_1.default)('accountnumber', props.className) },
        React.createElement("span", { className: "sr-only" }, formatted.screenreader),
        React.createElement("span", { "aria-hidden": true }, formatted.accountNumber)));
};
exports.AccountNumber = AccountNumber;
/* tslint:disable:no-string-literal */
exports.AccountNumber['defaultType'] = {
    number: '',
    options: {},
};
var OptionPropType = {
    productCode: PropTypes.string,
    productSubCode: PropTypes.string,
    limitGroup: PropTypes.string,
    limitGroupSize: PropTypes.number,
    mask: PropTypes.bool,
    prefix: PropTypes.string,
    screenreaderText: PropTypes.string,
};
exports.AccountNumber['propTypes'] = {
    className: PropTypes.string,
    number: PropTypes.string.isRequired,
    options: PropTypes.shape(OptionPropType),
};
/* tslint:enable:no-string-literal */
